// extracted by mini-css-extract-plugin
module.exports = {"readOnlyText":"style_readOnlyText__1zMcL","readOnlyList":"style_readOnlyList__2PssW","readOnlyListText":"style_readOnlyListText__JrByk"};